import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-destaque-abertura',
  templateUrl: './destaque-abertura.component.html',
  styleUrls: ['./destaque-abertura.component.scss']
})
export class DestaqueAberturaComponent implements OnInit, OnDestroy {
  // destaque: {nome, imagem, produtos} — vem de produtos em promocao (destaque) ou de uma vitrine
  @Input() destaque: any;
  @Input() empresa: any;
  @Input() isMobile: boolean;
  // SHEET (deslizante de baixo no mobile, padrao) ou DIALOG (janela central)
  @Input() formato: string;
  @Output() abrirProduto = new EventEmitter<any>();
  @Output() verTodos = new EventEmitter<void>();
  @Output() fechado = new EventEmitter<string>();

  produtos = [];
  economiaTotal = 0;
  // 4+ ofertas viram grade 2x2 no desktop (foto no topo, maior); ate 3 ficam em lista
  modoGrade = false;
  fechando: boolean;
  imagensComErro: any = {};
  // largura da sacola fixa no desktop: o modal centraliza na area do cardapio, nao na janela
  larguraSacola = 0;
  private overflowAnterior: string;

  ngOnInit() {
    // maior desconto primeiro; com foto na frente em caso de empate
    const produtos = (this.destaque && this.destaque.produtos || [])
      // informativo (história da loja, aviso) não é oferta: card de conteúdo, sem preço
      .filter((produto: any) => produto && !produto.indisponivel && produto.tipo !== 'informativo')
      .sort((a: any, b: any) => {
        const porDesconto = this.percentualDesconto(b) - this.percentualDesconto(a);
        if(porDesconto !== 0) return porDesconto;

        return (this.obtenhaImagem(b) ? 1 : 0) - (this.obtenhaImagem(a) ? 1 : 0);
      });

    this.modoGrade = produtos.length >= 4;
    // na grade sempre 4 (2x2 fechado, sem card orfao na ultima linha); o resto vai no "ver todas"
    this.produtos = produtos.slice(0, 4);
    this.economiaTotal = this.produtos.reduce(
      (total: number, produto: any) => total + this.economia(produto), 0);

    this.mecaSacola();

    this.overflowAnterior = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  @HostListener('window:resize')
  aoRedimensionar() {
    this.mecaSacola();
  }

  private mecaSacola() {
    const sacola: any = document.querySelector('.carrinho_desktop');

    // quando a sacola esta escondida (mobile, captacao de lead, finalizacao) a largura e 0
    this.larguraSacola = sacola ? Math.round(sacola.getBoundingClientRect().width) : 0;
  }

  ngOnDestroy() {
    document.body.style.overflow = this.overflowAnterior || '';
  }

  @HostListener('document:keydown.escape')
  aoTeclarEsc() {
    this.feche('esc');
  }

  exibirComoSheet() {
    return this.isMobile && String(this.formato || 'SHEET').toUpperCase() !== 'DIALOG';
  }

  // No celular a janela central ocupa quase a tela toda: com a largura de desktop
  // os nomes quebram em duas linhas e mal cabem dois produtos. E aqui o scrim faz
  // falta — e ele que separa a janela do cardapio, papel que no sheet e da borda.
  exibirComoDialogMobile() {
    return this.isMobile && !this.exibirComoSheet();
  }

  // a grade so existe no desktop e so fecha com numero par de cards (sem orfao na
  // ultima linha); fora disso nao ha o que alternar e o controle nem aparece
  podeAlternarModo() {
    return !this.isMobile && this.produtos.length >= 2 && this.produtos.length % 2 === 0;
  }

  useModo(grade: boolean) {
    this.modoGrade = grade;
  }

  obtenhaImagem(produto: any) {
    if(!produto || !produto.imagens || !produto.imagens.length) return null;

    return '/images/empresa/' + produto.imagens[0].linkImagem;
  }

  // duas linhas cheias e sem reticencia: corta na ultima palavra que cabe na
  // largura do card (a grade e mais estreita que a lista)
  descricaoCurta(produto: any) {
    const descricao = String(produto && produto.descricao || '').trim();
    const limite = this.modoGrade ? 92 : 132;

    if(descricao.length <= limite) return descricao;

    const corte = descricao.slice(0, limite);
    const ultimoEspaco = corte.lastIndexOf(' ');

    return (ultimoEspaco > limite * 0.6 ? corte.slice(0, ultimoEspaco) : corte)
      .replace(/[\s,;:.\-]+$/, '');
  }

  obtenhaPreco(produto: any) {
    return produto.valorMinimo ? produto.valorMinimo : produto.preco;
  }

  temImagem(produto: any) {
    return !!this.obtenhaImagem(produto) && !this.imagensComErro[produto.id];
  }

  marqueImagemComErro(produto: any) {
    this.imagensComErro[produto.id] = true;
  }

  percentualDesconto(produto: any) {
    const preco = Number(this.obtenhaPreco(produto) || 0);
    const precoAntigo = Number(produto.precoAntigo || 0);

    if(!preco || !precoAntigo || precoAntigo <= preco) return 0;

    return Math.round((1 - (preco / precoAntigo)) * 100);
  }

  economia(produto: any) {
    const preco = Number(this.obtenhaPreco(produto) || 0);
    const precoAntigo = Number(produto.precoAntigo || 0);

    return precoAntigo > preco ? precoAntigo - preco : 0;
  }

  clicouProduto(produto: any) {
    this.abrirProduto.emit(produto);
    this.feche('produto');
  }

  clicouVerTodos() {
    this.verTodos.emit();
    this.feche('ver_todos');
    return false;
  }

  fechar(origem: string) {
    this.feche(origem);
  }

  private feche(origem: string) {
    if(this.fechando) return;

    this.fechando = true;
    setTimeout(() => this.fechado.emit(origem), 200);
  }
}
